import client from '../httpClient';

const libraryGetSignitureApi = () => {
  return client.get('/libraries/signature/');
};

export default libraryGetSignitureApi;
